import * as api from "./middleware/api.middleware";
import { getActiveEnvironmentId } from "./environment.store";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "users";
const getAccessToken = () => getAuthHeader();

const getEnvironmentId = (fallback?: string | number | null) => {
  if (fallback !== undefined && fallback !== null && fallback !== "") {
    return `${fallback}`;
  }

  const activeEnvironmentId = getActiveEnvironmentId();
  if (activeEnvironmentId === undefined) {
    return undefined;
  }
  return `${activeEnvironmentId}`;
};

const getCustomerId = (fallback?: string | number | null) => {
  if (fallback !== undefined && fallback !== null) {
    return `${fallback}`;
  }
  return localStorage.getItem("customer_id");
};


export function getUserDetails(customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const getResponse = api.get<any>(
    `customers/${resolvedCustomerId}/${serviceUrl}`,
    getAccessToken()
  );
  return getResponse;
}

export function getUser(user_id: number) {
  const getResponse = api.get<any>(`${serviceUrl}/${user_id}`, getAccessToken());
  return getResponse;
}

export function postUserDetail(data: any, customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const getResponse = api.post<any>(
    `customers/${resolvedCustomerId}/invite`,
    data,
    getAccessToken()
  );
  return getResponse;
}

export function updateUserDetails(data: any, userId: number, customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const getResponse = api.put<any>(
    `customers/${resolvedCustomerId}/${serviceUrl}/${userId}`,
    data,
    getAccessToken()
  );
  return getResponse;
}

export function deleteUserDetails(userId: number, customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const getResponse = api.del<any>(
    `customers/${resolvedCustomerId}/${serviceUrl}/${userId}`,
    getAccessToken(),
    getAccessToken(),
  );
  return getResponse;
}

export function postSystemUser(
  data: { email: string; is_active?: boolean; customer_ids?: number[] },
  customerId: number | string,
  environmentId: number | string
) {
  const resolvedCustomerId = getCustomerId(customerId);
  // Password is generated server-side and returned once in the response.
  return api.post<any>(
    `customers/${resolvedCustomerId}/environments/${environmentId}/system_users`,
    data,
    getAccessToken()
  );
}

export function rotateSystemUserPassword(
  userId: number | string,
  customerId: number | string,
  environmentId: number | string
) {
  const resolvedCustomerId = getCustomerId(customerId);
  // Returns the new password once; does not invalidate active tokens.
  return api.post<any>(
    `customers/${resolvedCustomerId}/environments/${environmentId}/system_users/${userId}/rotate_password`,
    {},
    getAccessToken()
  );
}

export function environmentSpecificUserDetails(customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const resolvedEnvironmentId = getEnvironmentId();
  if (!resolvedCustomerId || !resolvedEnvironmentId) {
    return Promise.reject(new Error("Active customer or environment is not set"));
  }
  return api.get<any>(
    `customers/${resolvedCustomerId}/environments/${resolvedEnvironmentId}/${serviceUrl}`,
    getAccessToken()
  );
}

export function assignEnvironmentDetails(customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  if (!resolvedCustomerId) {
    return Promise.resolve([]);
  }
  return api.get<any>(
    `customers/${resolvedCustomerId}/environments/short`,
    getAccessToken()
  );
}

export function getEnvironments(customerId?: number | string) {
  const resolvedCustomerId = getCustomerId(customerId);
  const getResponse = api.get<any>(
    `customers/${resolvedCustomerId}/environments`,
    getAccessToken()
  );
  return getResponse;
}

export function setCurrentCustomer(customerId: number) {
  return api.put<any>(
    `users/me/current-customer/${customerId}`,
    {},
    getAccessToken()
  );
}

export function setCurrentEnvironment(environmentId: number) {
  return api.put<any>(
    `users/me/current-environment/${environmentId}`,
    {},
    getAccessToken()
  );
}
